import { render, staticRenderFns } from "./FeedbackShortcuts.vue?vue&type=template&id=6dd2f5ec&scoped=true"
import script from "./FeedbackShortcuts.vue?vue&type=script&lang=ts"
export * from "./FeedbackShortcuts.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackShortcuts.vue?vue&type=style&index=0&id=6dd2f5ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd2f5ec",
  null
  
)

export default component.exports